import { find, map, uniqBy } from 'lodash';

class CrossFormController {
  constructor($rootScope, eventsService, messageService) {
      this.$rootScope = $rootScope;
      this.eventsService = eventsService;
      this.messageService = messageService;
  }

  $onInit(){
      this.loading = true;
      this.select = [];
      if (this.source.cross) this.selections = this.source.cross.concat(new Array(3-this.source.cross.length))
      if (!this.crossEvents) {
        this.eventsService.collectCross(this.type).then(response => {
          this.crossEvents = response;
          this.properties = Object.keys(this.crossEvents);
          this.loading = false;
          if (this.source.cross){
            if (this.source.cross.length > 3){
              this.selections = this.source.cross.slice(0, 3);
            }
            for (let event in this.source.cross){
              this.selections[event] = find(this.crossEvents[this.source.cross[event].owning_property], { id: this.source.cross[event].id});
              this.select[event] = this.source.cross[event].owning_property;
            }
          }
        });
      } else {
        this.loading = false;
      }
  }

  onSave(){
      let dispatch = {
        'origin_type': this.type,
        'origin_id': this.source.id,
        'cross_sells': this.selections
      };

      return this.eventsService.updateCross(dispatch)
        .then(() => {
          this.messageService.success('The cross-sell events have been successfully updated');
          switch (this.type){
              case 'SpaDay':
                  this.formTab = 'day';
                  break;
              case 'Treatment':
                  this.formTab = 'treatment';
                  break;
          }
          this.messageService.push();
        }).catch(() => {
          this.messageService.failure('The cross-sell events could not be updated');
          this.messageService.push();
        });
  }

  currentEvent(key, event) {
    if ( (event.id === this.source.id) ) {
      return true;
    }
    return false;
  }

  removeEvent(index) {
    this.selections.splice(index,1);
    this.selections.push({});
  }
}

CrossFormController.$inject = [ '$rootScope', 'eventsService', 'messageService' ];

export default CrossFormController;


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/cross.form.controller.js